import { circleInfo } from "@simplybusiness/icons";
import type { DOMProps } from "@simplybusiness/mobius";
import { Flex, Icon } from "@simplybusiness/mobius";
import classNames from "classnames/dedupe";
import type { ReactNode, RefAttributes } from "react";

type InfoCardElement = HTMLDivElement;

export interface InfoCardProps
  extends DOMProps, RefAttributes<InfoCardElement> {
  children?: ReactNode;
  className?: string;
  header?: string;
}

export const InfoCard = ({ ref, ...props }: InfoCardProps) => {
  const { header, children, className, ...otherProps } = props;

  const classes = classNames("mobius", "mobius-info-card", className, {
    "--has-header": header,
  });
  const headerClasses = "mobius-info-card__header";
  const iconClasses = "mobius-info-card__icon";
  const contentClasses = "mobius-info-card__content";

  return (
    <Flex
      flexGrow={1}
      ref={ref}
      role="note"
      className={classes}
      {...otherProps}
    >
      <span className={iconClasses}>
        <Icon icon={circleInfo} size="sm" title="Important information" />
      </span>
      <div>
        {header && <p className={headerClasses}>{header}</p>}
        <div className={contentClasses}>{children}</div>
      </div>
    </Flex>
  );
};

InfoCard.displayName = "InfoCard";
